export interface UserData {
	id: string;
	displayName: string;
	imageSrc: string;
	username: string;
}

// @TODO check usage and delete
export class User {
	data?: any | UserData; //TODO: Migration typefix.

	constructor(data: UserData) {
		this.data = data;
	}

	get id() {
		return this.data.id;
	}

	get displayName() {
		return this.data.displayName;
	}

	get imageSrc() {
		return this.data.imageSrc;
	}

	get username() {
		return this.data.username;
	}

	toString() {
		return this.data.username;
	}

	toJSON() {
		return this.data;
	}
}
